"use client";

/**
 * Suppress ResumePDF development errors.
 * See ResumePDF doc string for context.
 */
if (typeof window !== "undefined" && window.location.hostname === "localhost") {
  const consoleError = console.error;
  const SUPPRESSED_WARNINGS = [
    "DOCUMENT",
    "PAGE", 
    "TEXT",
    "VIEW",
    "LINK",
    "IMAGE",
    "Received `true` for a non-boolean attribute `fixed`",
    "Received `false` for a non-boolean attribute `wrap`",
    "React does not recognize the `minPresenceAhead` prop on a DOM element",
    "React does not recognize the `maxPresenceAhead` prop on a DOM element",
    "React does not recognize the `orphans` prop on a DOM element",
    "React does not recognize the `widows` prop on a DOM element",
    "If you want to write it to the DOM, pass a string instead",
    "If you used to conditionally omit it with wrap={condition && value}, pass wrap={condition ? value : undefined} instead",
  ];
  console.error = function filterWarnings(msg, ...args) {
    if (!SUPPRESSED_WARNINGS.some((entry) => 
      (typeof args[0] === 'string' && args[0].includes(entry)) ||
      (typeof msg === 'string' && msg.includes(entry))
    )) {
      consoleError(msg, ...args);
    }
  };
}

export const SuppressResumePDFErrorMessage = () => {
  return <></>;
};
